export default "__VITE_ASSET__6cNL7aYD__"